(function () {
  const PARENT_UID_PROP = "_bundle_parent_uid";
  const PHONE_UID_PROP = "_bundle_uid";
  const PARENT_VARIANT_PROP = "_bundle_parent_variant_id";
  const SOURCE_PROP = "_pb_source";

  let isCleaning = false;
  let isBusy = false;

  function isDrawerOpen() {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer) return false;
    return drawer.classList.contains("active") || drawer.classList.contains("animate");
  }

  async function getCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return res.json();
  }

  async function updateByKeys(updatesObj) {
    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates: updatesObj }),
    });
    return res.json();
  }

  async function addVariantToCart(variantId, props) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: props || {},
      }),
    });

    try {
      return await res.json();
    } catch (_) {
      return null;
    }
  }

  function getRootPath() {
    return window.Shopify?.routes?.root ? window.Shopify.routes.root : "/";
  }

  async function refreshDrawerSections() {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer) return;

    if (typeof drawer.getSectionsToRender === "function" && typeof drawer.renderContents === "function") {
      const root = getRootPath();
      const sections = drawer.getSectionsToRender().map((s) => s.id);
      const url = root + "cart?sections=" + encodeURIComponent(sections.join(","));

      try {
        const sectionsJson = await fetch(url, { method: "GET" }).then((r) => r.json());

        try {
          const cart = await getCart();
          const empty = !cart.items || cart.items.length === 0;
          drawer.classList.toggle("is-empty", empty);
        } catch (_) {}

        drawer.renderContents({ sections: sectionsJson, id: drawer.productId || null });

        if (typeof drawer.open === "function") {
          setTimeout(() => drawer.open(), 0);
        }

        document.dispatchEvent(new CustomEvent("cart:updated"));
        return;
      } catch (e) {
        console.error("[PB] Drawer refresh failed", e);
      }
    }

    if (window.PUB_SUB_EVENTS && typeof window.publish === "function") {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "pb-refresh-drawer" });
    }
    document.dispatchEvent(new CustomEvent("cart:updated"));
  }

  function getFirstLineQtyFromDOM() {
    const qtyInput =
      document.querySelector('#main-cart-items input.quantity__input[data-index="1"]') ||
      document.querySelector('#CartDrawer input.quantity__input[data-index="1"]') ||
      document.querySelector('input.quantity__input[data-index="1"]');

    if (!qtyInput) return null;
    const q = parseInt(qtyInput.value, 10);
    if (!Number.isFinite(q) || q < 0) return null;
    return q;
  }

  async function refreshCartUIFast() {
    const cartItemsEl = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");

    if (!cartItemsEl || typeof cartItemsEl.getSectionsToRender !== "function") {
      if (window.PUB_SUB_EVENTS && window.publish) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "bundle-cleanup" });
      }
      document.dispatchEvent(new CustomEvent("cart:updated"));
      return;
    }

    const sectionsToRender = cartItemsEl.getSectionsToRender();
    const sections = sectionsToRender.map((s) => s.section).filter(Boolean);

    let qty = getFirstLineQtyFromDOM();

    if (qty === null) {
      try {
        const cart = await getCart();
        if (!cart || !cart.items || cart.items.length === 0) {
          if (typeof cartItemsEl.onCartUpdate === "function") cartItemsEl.onCartUpdate();
          document.dispatchEvent(new CustomEvent("cart:updated"));
          return;
        }
        qty = cart.items[0].quantity;
      } catch (e) {
        if (typeof cartItemsEl.onCartUpdate === "function") cartItemsEl.onCartUpdate();
        document.dispatchEvent(new CustomEvent("cart:updated"));
        return;
      }
    }

    const body = JSON.stringify({
      line: 1,
      quantity: qty,
      sections: sections,
      sections_url: window.location.pathname,
    });

    try {
      const res = await fetch("" + routes.cart_change_url, { ...fetchConfig(), body });
      const txt = await res.text();
      const r = JSON.parse(txt);

      sectionsToRender.forEach((s) => {
        const el = document.getElementById(s.id);
        if (!el) return;
        const html = r.sections && r.sections[s.section];
        if (!html) return;
        const target = el.querySelector(s.selector) || el;
        const doc = new DOMParser().parseFromString(html, "text/html");
        const inner = doc.querySelector(s.selector);
        target.innerHTML = inner ? inner.innerHTML : (doc.body ? doc.body.innerHTML : html);
      });

      if (window.PUB_SUB_EVENTS && window.publish) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "bundle-cleanup" });
      }

      document.dispatchEvent(new CustomEvent("cart:updated"));
    } catch (e) {
      if (typeof cartItemsEl.onCartUpdate === "function") cartItemsEl.onCartUpdate();
      document.dispatchEvent(new CustomEvent("cart:updated"));
    }
  }

  async function refreshAppropriateUI() {
    if (isDrawerOpen()) {
      await refreshDrawerSections();
    } else {
      await refreshCartUIFast();
    }
  }

  function optimisticSetBoxState(boxEl, state) {
    if (!boxEl) return;
    const addBtn = boxEl.querySelector(".bundle-add-btn");
    const removeBtn = boxEl.querySelector(".bundle-remove-btn");
    const statusEl = boxEl.querySelector(".bundle-status-text");

    if (state === "adding") {
      if (addBtn) {
        addBtn.setAttribute("aria-busy", "true");
        addBtn.setAttribute("disabled", "disabled");
        addBtn.classList.add("is-loading");
      }
      if (removeBtn) removeBtn.setAttribute("disabled", "disabled");
      if (statusEl) statusEl.textContent = "Adding…";
    }

    if (state === "removing") {
      if (removeBtn) {
        removeBtn.setAttribute("aria-busy", "true");
        removeBtn.setAttribute("disabled", "disabled");
        removeBtn.classList.add("is-loading");
      }
      if (addBtn) addBtn.setAttribute("disabled", "disabled");
      if (statusEl) statusEl.textContent = "Removing…";
    }
  }

  async function addBundle(variantId, parentUid, source) {
    const props = { [PARENT_UID_PROP]: parentUid };

    if (source) {
      props[SOURCE_PROP] = source;
    } else if (window.location.pathname === "/cart") {
      props[SOURCE_PROP] = "pb-cart";
    }

    await addVariantToCart(variantId, props);
    await refreshAppropriateUI();
  }

  async function removeByKey(lineKey) {
    await updateByKeys({ [lineKey]: 0 });
    await refreshAppropriateUI();
  }

  function bindBundleBoxButtons() {
    document.addEventListener(
      "click",
      (e) => {
        const addBtn = e.target.closest(".bundle-add-btn");
        const removeBtn = e.target.closest(".bundle-remove-btn");

        if (!addBtn && !removeBtn) return;

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

        if (isBusy) return;
        isBusy = true;

        if (addBtn) {
          const variantId = addBtn.dataset.variantId;
          const parentUid = addBtn.dataset.parentUid;
          const source = addBtn.dataset.pbSource || null;
          const boxEl = addBtn.closest(".bundle-box") || addBtn.closest(".bundle-row") || addBtn.parentElement;

          if (!variantId || !parentUid) {
            isBusy = false;
            return;
          }

          optimisticSetBoxState(boxEl, "adding");

          addBundle(variantId, parentUid, source)
            .catch(console.error)
            .finally(() => {
              isBusy = false;
            });

          return;
        }

        if (removeBtn) {
          const key = removeBtn.dataset.bundleKey;
          const boxEl = removeBtn.closest(".bundle-box") || removeBtn.closest(".bundle-row") || removeBtn.parentElement;

          if (!key) {
            isBusy = false;
            return;
          }

          optimisticSetBoxState(boxEl, "removing");

          removeByKey(key)
            .catch(console.error)
            .finally(() => {
              isBusy = false;
            });
        }
      },
      true
    );
  }

  async function removeByIndex(lineIndex) {
    const cart = await getCart();
    const clickedItem = cart.items[lineIndex - 1];
    if (!clickedItem) return;

    const updates = {};
    updates[clickedItem.key] = 0;

    const clickedIsProtectionUid = clickedItem.properties && clickedItem.properties[PARENT_UID_PROP];
    const clickedIsProtectionVariant = clickedItem.properties && clickedItem.properties[PARENT_VARIANT_PROP];

    if (!clickedIsProtectionUid && !clickedIsProtectionVariant) {
      const uid = clickedItem.properties && clickedItem.properties[PHONE_UID_PROP];
      const parentVariantId = clickedItem.variant_id;

      for (const item of cart.items) {
        const parentUid = item.properties && item.properties[PARENT_UID_PROP];

        if (uid && parentUid && parentUid === uid) {
          updates[item.key] = 0;
          continue;
        }

        if (!uid) {
          const parentVar = item.properties && item.properties[PARENT_VARIANT_PROP];
          if (parentVar && parseInt(parentVar, 10) === parentVariantId) {
            updates[item.key] = 0;
          }
        }
      }
    }

    await updateByKeys(updates);
    await refreshAppropriateUI();
  }

  function bindUnifiedRemovalInterceptors() {
    document.addEventListener(
      "click",
      (e) => {
        const removeBtn = e.target.closest("cart-remove-button");
        if (!removeBtn) return;

        const lineIndex = parseInt(removeBtn.dataset.index, 10);
        if (!lineIndex) return;

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

        removeByIndex(lineIndex).catch((err) => {
          console.error("Remove interceptor failed; falling back", err);
          refreshAppropriateUI().catch(console.error);
        });
      },
      true
    );

    document.addEventListener(
      "change",
      (e) => {
        const qtyInput = e.target.closest('input.quantity__input[name="updates[]"]');
        if (!qtyInput) return;

        const val = parseInt(qtyInput.value, 10);
        if (val !== 0) return;

        const lineIndex = parseInt(qtyInput.dataset.index, 10);
        if (!lineIndex) return;

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

        removeByIndex(lineIndex).catch((err) => {
          console.error("Qty=0 interceptor failed; falling back", err);
          refreshAppropriateUI().catch(console.error);
        });
      },
      true
    );
  }

  async function cleanupOrphanProtectionLinesNoReload() {
    if (isCleaning) return;
    isCleaning = true;

    try {
      const cart = await getCart();

      const phoneUids = new Set(
        cart.items
          .map((i) => (i.properties && i.properties[PHONE_UID_PROP]) || i.key)
          .filter(Boolean)
      );

      const variantIdsInCart = new Set(cart.items.map((i) => i.variant_id));

      const updates = {};
      let found = false;

      for (const item of cart.items) {
        const parentUid = item.properties && item.properties[PARENT_UID_PROP];
        if (parentUid) {
          if (!phoneUids.has(parentUid)) {
            updates[item.key] = 0;
            found = true;
          }
          continue;
        }

        const parentVar = item.properties && item.properties[PARENT_VARIANT_PROP];
        if (parentVar) {
          const parentVariantId = parseInt(parentVar, 10);
          if (!variantIdsInCart.has(parentVariantId)) {
            updates[item.key] = 0;
            found = true;
          }
        }
      }

      if (!found) return;

      await updateByKeys(updates);
      await refreshAppropriateUI();
    } catch (err) {
      console.error("Bundle cleanup failed", err);
    } finally {
      setTimeout(() => {
        isCleaning = false;
      }, 300);
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    bindBundleBoxButtons();
    bindUnifiedRemovalInterceptors();
    cleanupOrphanProtectionLinesNoReload();
  });

  document.addEventListener("cart:updated", () => {
    cleanupOrphanProtectionLinesNoReload();
  });
})();